// extracted by mini-css-extract-plugin
module.exports = {"form":"_3RG5En","input":"_3ivLpV","button":"_6TBXMR"};